/* SkinFairytale Growth Serum landing page. gs-lp.js, 15 Oct 2026: all 20 scripts (plus the editor tidy script first, and the short flip cards, the card peek, the gift fold and the per-day line break last) of the A2 v8 reference page, unchanged, in their original order. Do not edit. */
/* Editor tidy: when a text is cleared in the theme editor, hide the element it sat in (heading, paragraph, list item, label, button),
   so clearing a text removes that part. Only elements that hold a cleared editor text (marker from snippets/gs-text) and nothing else. */
(function(){
  var MEDIA='img,svg,video,picture,iframe,input,select,textarea';
  function tidy(root){
    (root||document).querySelectorAll('.sfg-lp-section i.gs-empty').forEach(function(m){
      var el=m.parentElement, hops=0;
      while(el&&hops<3&&!el.classList.contains('sfg-lp-section')){
        if(el.matches('td,th,tr,thead,tbody,table')||el.textContent.trim()!==''||el.querySelector(MEDIA)) break;
        el.setAttribute('data-gs-empty','');
        var p=el.parentElement; if(!p||p.children.length>1) break;
        el=p; hops++;
      }
    });
  }
  tidy();
  document.addEventListener('shopify:section:load',function(e){tidy(e.target);});
})();
/* QUIZ PLAN (20 Oct 2026). Coming from the hair quiz (?quiz=1&plan=single|phase1|full), the plan she picked is the one that opens
   in the first plan selector (#offer): on phones the picker starts on it (the PLANS script below reads data-plan-default), on desktop
   it gets a deep green ring. Phase 1 already carries the gold "recommended" ring, so it only moves the default there. Runs before PLANS. */
(function(){
  try{
    var q=new URLSearchParams(location.search), pick=q.get('plan');
    if(!q.get('quiz')||!pick) return;
    var box=document.querySelector('#offer [data-anim="plans"]')||document.querySelector('#offer'); if(!box) return;
    var plans=box.querySelectorAll('[data-plan]'); if(plans.length<3) return;
    var map={single:plans[0],phase1:plans[1],full:plans[2]}, el=map[pick]; if(!el) return;
    Array.prototype.forEach.call(plans,function(p){ p.removeAttribute('data-plan-default'); });
    el.setAttribute('data-plan-default','');
    el.setAttribute('data-quiz-pick','');
    if(pick!=='phase1') el.style.boxShadow='0 0 0 3px var(--gs-c-deep,#1B3A30)';
  }catch(e){}
})();
/* Hide the sticky mobile button while the hero button or a plan selector is on screen. */
(function(){
  var bar=document.querySelector('.stickyCta'), sel=['.hCta','#offer','#offer2'], seen=new Map();
  if(!bar||!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ seen.set(e.target, e.isIntersecting); });
    var any=false; seen.forEach(function(v){ if(v) any=true; });
    bar.classList.toggle('off', any);
  },{threshold:0.05});
  sel.forEach(function(q){ var el=document.querySelector(q); if(el) io.observe(el); });
})();
;
/* ANIMATIONS: play when seen (only in the -animated file).
   Any element with data-gs-onview gets the class gs-armed straight away and the class gs-play once it scrolls into view.
   The number in the attribute is how much of the element must be visible (0.7 = 70%); 0.35 if left empty.
   If the element is taller than the screen, that share is lowered so it can always be reached.
   ON PHONES (860px and below) an element can be started by where it is on the screen instead, with data-gs-when:
   - data-gs-when="reveal": for quick one-time entrances (a card popping or rising in). It plays when the top of the element comes up past REVEAL,
     a line 83% down the screen. That is the "90% line" of our reference with the sticky button bar taken off.
   - data-gs-when="watch": for something the visitor has to watch (a bar that tells a story, a number counting up). It plays when the top of the
     element comes up past WATCH, 58% down the screen, where the eye is about to arrive, and not before the whole element is above the sticky
     button bar (if the element is too tall for that, it plays when its top reaches the top of the zone the eye rests in, 25% down).
   - data-gs-when="0.8" (any number between 0 and 1): the same as "watch" but with its own line, here 80% down the screen. For something that starts
     hidden and would leave a hole in the page while it waits for the 58% line (the price in section 15). A higher number starts it earlier.
     It still waits until the whole element is above the sticky button bar.
   The reference is Knowledge/viewport_gaze_hot_zones_by_device.svg: on a phone the eye rests between 25% and 50% of the screen height.
   The three numbers and the height of the sticky bar are at the top of the script. On wider screens data-gs-when is ignored and data-gs-onview decides,
   unless the element also carries data-gs-when-wide="watch": then on desktop it plays when its top edge comes up past a line 62% down the screen
   (WATCH_WIDE; on a laptop or monitor the eye rests between 20% and 55%). The marked phrases use this, so the marker is drawn when she gets to it and not while it is still at the bottom edge.
   The motion itself is CSS. If this script does not run, nothing is hidden and the page shows its still version.
   Counting numbers: inside such an element, anything with data-gs-count="80" (or "1.05" for a price) counts from 0 to that number when the element starts playing
   (1.5 seconds; the page itself already holds the final number, so without the script it simply shows 80).
   On phones a number only counts if its element carries data-gs-when, so each counting number is switched on for phones one by one
   (the +80% in the study, the price in section 15 and the 180 in the guarantee badge are). Counting is off for visitors with reduced motion.
   An element with data-gs-phones-only is left alone on wider screens altogether (the 180 badge: it counts on phones, on desktop it is simply there).
   It stands alone: it needs no other script, and it runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!('IntersectionObserver' in window)) return;
  /* phones only, see data-gs-when above: shares of the screen height, and the height of the sticky button bar in pixels */
  var REVEAL=0.83, WATCH=0.58, ZONE_TOP=0.25, BAR=80;
  /* desktop, for data-gs-when-wide="watch": on a laptop or monitor the eye rests between 20% and 55% of the screen height */
  var WATCH_WIDE=0.62, ZONE_TOP_WIDE=0.2;
  function quiet(root){
    if(!window.matchMedia||window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    if(window.matchMedia('(min-width:861px)').matches) return false;
    return !root.getAttribute('data-gs-when'); /* phones: only elements set up for phones */
  }
  function countUp(root){
    if(quiet(root)||!window.requestAnimationFrame) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-gs-count]'),function(n){
      var raw=n.getAttribute('data-gs-count'), to=parseFloat(raw); if(isNaN(to)) return;
      /* decimals come from the attribute (1.05 has two); the decimal mark is taken from the number shown in the page, so a Polish "1,05" keeps its comma */
      var dec=(raw.split('.')[1]||'').length, comma=n.textContent.indexOf(',')>-1;
      function show(v){ var t=v.toFixed(dec); n.textContent=comma?t.replace('.',','):t; }
      if(dec>0){
        /* same number of characters all the way, so hold the width steady and nothing beside the number shifts */
        var w1=n.offsetWidth; show(0); var w0=n.offsetWidth;
        n.style.display='inline-block'; n.style.minWidth=Math.max(w0,w1)+'px'; n.style.textAlign='left';
      } else {
        var box=n.parentNode; if(box&&box.offsetWidth) box.style.minWidth=box.offsetWidth+'px';
        show(0);
      }
      var ms=1500, t0=null;
      requestAnimationFrame(function step(ts){
        if(t0===null) t0=ts;
        var p=Math.min(1,(ts-t0)/ms), e=1-Math.pow(1-p,3);
        show(to*e);
        if(p<1) requestAnimationFrame(step);
      });
    });
  }
  function init(root){
    var els=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-gs-onview]');
    Array.prototype.forEach.call(els,function(el){
      if(el.getAttribute('data-gs-ready')) return;
      /* data-gs-phones-only: this element is left alone on wider screens (nothing is hidden, nothing counts) */
      if(el.hasAttribute('data-gs-phones-only')&&window.matchMedia&&window.matchMedia('(min-width:861px)').matches) return;
      el.setAttribute('data-gs-ready','1');
      el.classList.add('gs-armed');
      var need=parseFloat(el.getAttribute('data-gs-onview')); if(!(need>0&&need<=1)) need=0.35;
      var h=el.offsetHeight, vh=window.innerHeight||0, opts;
      if(h>0&&vh>0) need=Math.min(need,0.9*vh/h);
      opts={threshold:need};
      var when=el.getAttribute('data-gs-when');
      var own=parseFloat(when); if(!(own>0&&own<1)) own=0; /* data-gs-when="0.8": its own line, see above */
      if((when==='reveal'||when==='watch'||own)&&vh>0&&window.matchMedia&&!window.matchMedia('(min-width:861px)').matches){
        /* phones: a line across the screen; the element plays when its top edge comes up past it */
        var line=vh*(own||(when==='reveal'?REVEAL:WATCH));
        if(when!=='reveal'&&h>0) line=Math.max(Math.min(line,vh-BAR-h),vh*ZONE_TOP);
        need=0; opts={threshold:0,rootMargin:'0px 0px -'+Math.round(vh-line)+'px 0px'};
      } else if(vh>0&&el.getAttribute('data-gs-when-wide')==='watch'&&window.matchMedia&&window.matchMedia('(min-width:861px)').matches){
        /* desktop, only for elements that ask for it: the same idea with the desktop numbers (no sticky bar there) */
        var wline=Math.max(Math.min(vh*WATCH_WIDE,vh-h),vh*ZONE_TOP_WIDE);
        need=0; opts={threshold:0,rootMargin:'0px 0px -'+Math.round(vh-wline)+'px 0px'};
      }
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting&&e.intersectionRatio>=need-0.01){
          el.classList.add('gs-play'); countUp(el); io.disconnect();
          /* data-gs-done="1300": that many milliseconds later the element also gets gs-done, for effects that should only start once the entrance is over */
          var done=parseInt(el.getAttribute('data-gs-done'),10); if(done>0) setTimeout(function(){ el.classList.add('gs-done'); },done);
        } });
      },opts);
      io.observe(el);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ init(); }); else init();
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
;
/* TRACK BALL (only in the -animated file). Section 9, month by month.
   A ball rides the line between the numbered circles and follows the scroll in both directions.
   It sits level with a reading line, but never before the first circle or past the last one. The reading line is 55% down the screen
   on desktop and 45% down on phones (REF_WIDE and REF_PHONE below): on a phone the eye rests higher, between 25% and 50% of the screen height
   (see Knowledge/viewport_gaze_hot_zones_by_device.svg), and the sticky button bar covers the bottom of the screen.
   Where the line is broken (between the two phases) it hides at the end of the line and waits under the next circle.
   The line fills behind it, reached circles get a ring, and arriving at the last circle sets off the sparks
   (again only after the ball has gone back above the circle before it).
   Desktop and phones; not for visitors with reduced motion. Without this script the list is simply still.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.requestAnimationFrame||!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var REF_WIDE=0.55, REF_PHONE=0.45;
  var tracks=[], queued=false;
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="track"]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-gs-ready')) return;
      var ball=el.querySelector('[data-track-ball]'), dots=el.querySelectorAll('[data-track-dot]');
      if(!ball||dots.length<2) return;
      el.setAttribute('data-gs-ready','1');
      tracks.push({el:el,ball:ball,dots:dots,burst:el.querySelector('[data-track-burst]'),lastY:null,done:false});
    });
    ask();
  }
  function lineOf(dot){ var rail=dot.parentNode; return rail?rail.querySelector('[data-track-line]'):null; }
  function update(){
    queued=false;
    var on=!calm.matches, vh=window.innerHeight, ref=vh*(wide.matches?REF_WIDE:REF_PHONE);
    tracks.forEach(function(t){
      if(!document.body.contains(t.el)) return;
      t.el.classList.toggle('gs-track-on',on);
      if(!on) return;
      var box=t.el.getBoundingClientRect();
      if(box.bottom<-300||box.top>vh+300) return;
      var c=[], i, n=t.dots.length, r;
      for(i=0;i<n;i++){ r=t.dots[i].getBoundingClientRect(); c.push({y:r.top+r.height/2,x:r.left+r.width/2}); }
      var k=-1; for(i=0;i<n;i++){ if(c[i].y<=ref) k=i; }
      var y, hide=false;
      if(k<0){ y=c[0].y; }
      else if(k===n-1){ y=c[n-1].y; }
      else{
        var ln=lineOf(t.dots[k]), end=ln?ln.getBoundingClientRect().bottom:c[k].y;
        if(c[k+1].y-end<=30){ y=ref; }            /* the line runs straight on to the next circle */
        else if(ref<end){ y=ref; }                /* still on the line before a break */
        else{ y=c[k+1].y; hide=true; }            /* in the break: wait under the next circle */
      }
      /* ball */
      if(t.lastY!==null&&Math.abs((y-box.top)-t.lastY)>80) t.ball.classList.add('gs-jump'); else t.ball.classList.remove('gs-jump');
      t.lastY=y-box.top;
      t.ball.style.transform='translate('+(c[0].x-box.left).toFixed(1)+'px,'+(y-box.top).toFixed(1)+'px)';
      t.ball.classList.toggle('gs-hide',hide);
      /* lines and circles */
      for(i=0;i<n;i++){
        t.dots[i].classList.toggle('gs-on',i<=k); /* a circle gets its ring when the reading line reaches it, not when the ball waits under it in the break between the phases (Lan, 14 Oct) */
        var l=lineOf(t.dots[i]);
        if(l){ var lr=l.getBoundingClientRect(), f=lr.height>0?(y-lr.top)/lr.height:0; l.style.setProperty('--gs-fill',Math.max(0,Math.min(1,f)).toFixed(3)); }
      }
      /* sparks at the last circle */
      var atEnd=(k===n-1);
      if(atEnd&&!t.done){
        t.done=true;
        if(t.burst){ t.burst.classList.remove('gs-go'); void t.burst.offsetWidth; t.burst.classList.add('gs-go'); }
        var last=t.dots[n-1]; last.classList.remove('gs-pop'); void last.offsetWidth; last.classList.add('gs-pop');
      }
      if(t.done&&k<n-2) t.done=false;
    });
  }
  function ask(){ if(!queued){ queued=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll',ask,{passive:true});
  window.addEventListener('resize',ask);
  window.addEventListener('load',ask);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* VIDEO STRIP (only in the -animated file). Section 10.
   Turns the row of video tiles into an endless strip that moves right to left.
   It copies the tiles as many times as the screen width needs, then once more, so the loop has no seam.
   Speed stays the same however many tiles there are: 7 seconds per tile.
   The strip only moves while it is on screen (even partly). Desktop and phones; not for visitors with reduced motion.
   On phones it also sets where the loop starts, so that the first tile stands PHONE_INSET pixels in from the left edge, in line with the text.
   SWIPE AND DRAG (v8, 15 Oct 2026, Lan): the strip can be pushed by hand. A finger swipe, a mouse drag or a sideways trackpad scroll moves it left or right;
   it keeps a little of the swipe's speed and glides to a stop, then carries on by itself. Up-and-down swipes still scroll the page (the strip only takes
   sideways moves). A tap or click that does not move more than MOVE pixels still opens the video; after a real drag the tap is ignored, so a swipe never
   opens a video by accident. The movement is done here (not by the CSS animation, which is only the fallback), so a swipe can pick up exactly where the
   strip is. While a video is open (gs-hold) the strip stands still.
   Without this script the tiles are a row you can scroll sideways.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var SECONDS_PER_TILE=7, PHONE_INSET=24, MOVE=6, FRICTION=0.94, strips=[], timer=null, raf=0, last=0;
  function wrap(st){ if(!st.loopW) return; while(st.pos<=-st.loopW) st.pos+=st.loopW; while(st.pos>0) st.pos-=st.loopW; }
  function paint(st){ st.track.style.transform='translate3d('+st.pos.toFixed(2)+'px,0,0)'; }
  function build(st){
    var track=st.track, mq=st.el;
    Array.prototype.slice.call(track.querySelectorAll('[data-mq-clone]')).forEach(function(c){ track.removeChild(c); });
    var on=!calm.matches;
    mq.classList.toggle('gs-mq-on',on); mq.classList.toggle('gs-mq-js',on);
    st.reps=0; st.wide=wide.matches; st.loopW=0; track.style.transform='';
    if(!on) return;
    var items=Array.prototype.slice.call(track.children); if(!items.length) return;
    var setW=track.scrollWidth; if(!setW) return;
    var reps=Math.max(1,Math.ceil((mq.clientWidth+60)/setW)), copies=reps*2-1, k;
    for(k=0;k<copies;k++){
      items.forEach(function(it){ var c=it.cloneNode(true); c.setAttribute('data-mq-clone',''); c.setAttribute('aria-hidden','true'); track.appendChild(c); });
    }
    var dur=items.length*reps*SECONDS_PER_TILE;
    st.loopW=track.scrollWidth/2; st.speed=st.loopW/dur;
    /* phones: start where the first tile is PHONE_INSET in from the left */
    st.pos=wide.matches?0:-(st.loopW-PHONE_INSET); st.vel=0; wrap(st); paint(st);
    st.reps=reps; st.w=mq.clientWidth;
    kick();
  }
  function tick(now){
    var dt=last?Math.min(0.05,(now-last)/1000):0; last=now; var any=false;
    strips.forEach(function(st){
      if(!st.loopW||!document.body.contains(st.el)) return;
      if(st.drag) { any=true; return; }
      var running=st.el.classList.contains('gs-run')&&!st.el.classList.contains('gs-hold')&&!document.hidden;
      if(Math.abs(st.vel)>20){ st.pos+=st.vel*dt; st.vel*=Math.pow(FRICTION,dt*60); any=true; }
      else { st.vel=0; if(running){ st.pos-=st.speed*dt; any=true; } }
      wrap(st); paint(st);
    });
    if(any) raf=requestAnimationFrame(tick); else { raf=0; last=0; }
  }
  function kick(){ if(!raf){ last=0; raf=requestAnimationFrame(tick); } }
  function hands(st){
    var el=st.el, sx=0, sy=0, sp=0, moved=false, id=null, lx=0, lt=0, v=0, block=false;
    el.style.touchAction='pan-y';
    el.addEventListener('dragstart',function(e){ if(el.classList.contains('gs-mq-js')) e.preventDefault(); });
    el.addEventListener('pointerdown',function(e){
      if(!st.loopW||(e.pointerType==='mouse'&&e.button!==0)) return;
      id=e.pointerId; sx=lx=e.clientX; sy=e.clientY; sp=st.pos; moved=false; lt=performance.now(); v=0; st.vel=0;
    });
    el.addEventListener('pointermove',function(e){
      if(id!==e.pointerId) return;
      var dx=e.clientX-sx, dy=e.clientY-sy;
      if(!moved){
        if(Math.abs(dy)>MOVE&&Math.abs(dy)>Math.abs(dx)){ id=null; return; }
        if(Math.abs(dx)<=MOVE) return;
        moved=true; st.drag=true; el.classList.add('gs-drag'); try{ el.setPointerCapture(id); }catch(_){}
      }
      var now=performance.now(), d=now-lt;
      if(d>0){ v=0.8*((e.clientX-lx)/d*1000)+0.2*v; }
      lx=e.clientX; lt=now;
      st.pos=sp+dx; wrap(st); paint(st); sp=st.pos-dx;
      e.preventDefault();
    });
    function end(e){
      if(id!==e.pointerId) return;
      id=null;
      if(moved){ block=true; setTimeout(function(){ block=false; },400); st.vel=(performance.now()-lt<120)?Math.max(-3000,Math.min(3000,v)):0; }
      st.drag=false; el.classList.remove('gs-drag'); kick();
    }
    el.addEventListener('pointerup',end); el.addEventListener('pointercancel',end);
    el.addEventListener('click',function(e){ if(block){ e.preventDefault(); e.stopPropagation(); block=false; } },true);
    el.addEventListener('wheel',function(e){
      if(!st.loopW||Math.abs(e.deltaX)<=Math.abs(e.deltaY)) return;
      e.preventDefault(); st.vel=0; st.pos-=e.deltaX; wrap(st); paint(st); kick();
    },{passive:false});
  }
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="marquee"]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-gs-ready')) return;
      var track=el.querySelector('[data-mq-track]'); if(!track) return;
      el.setAttribute('data-gs-ready','1');
      var st={el:el,track:track,reps:0,w:0,wide:null,pos:0,vel:0,speed:0,loopW:0,drag:false}; strips.push(st); build(st); hands(st);
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ el.classList.toggle('gs-run',e.isIntersecting); if(e.isIntersecting) kick(); }); },{threshold:0}).observe(el);
      } else el.classList.add('gs-run');
      new MutationObserver(function(){ kick(); }).observe(el,{attributes:true,attributeFilter:['class']});
    });
  }
  function rebuild(){ strips.forEach(function(st){ if(document.body.contains(st.el)) build(st); }); }
  window.addEventListener('resize',function(){ clearTimeout(timer); timer=setTimeout(function(){
    strips.forEach(function(st){ var on=!calm.matches; if(on!==st.el.classList.contains('gs-mq-on')||wide.matches!==st.wide||(on&&st.el.clientWidth>st.w)) build(st); });
  },200); });
  document.addEventListener('visibilitychange',kick);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  window.addEventListener('load',rebuild);
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* PLANS (only in the -animated file). Section 13, the three plans, on phones.
   A row marked data-anim="plans" holds the plans (data-plan). The script adds gs-plans-on to the row, which switches the phone layout to the picker (CSS, phones only),
   and gs-sel to the chosen plan, which opens it. It starts on the plan marked data-plan-default (the first one if none is marked).
   A tap on a closed plan opens it and closes the one that was open; a tap inside the open plan does nothing special, so its button works as always.
   When the plan above closes, the page gets shorter; if that would leave the top of the newly opened plan above the screen, the page is scrolled so it is in view.
   On phones the plans also get role, tabindex and aria-expanded so they work from a keyboard (Enter or Space).
   On desktop the classes have no effect: the three cards stand side by side. Without this script phones show the three full cards.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)');
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="plans"]');
    Array.prototype.forEach.call(found,function(box){
      if(box.getAttribute('data-gs-ready')) return;
      var plans=box.querySelectorAll('[data-plan]');
      if(plans.length<2) return;
      box.setAttribute('data-gs-ready','1');
      var phone=!wide.matches;
      function pick(p,show){
        Array.prototype.forEach.call(plans,function(q){
          var on=q===p; q.classList.toggle('gs-sel',on);
          if(phone) q.setAttribute('aria-expanded',on?'true':'false');
        });
        if(show&&!wide.matches){ var r=p.getBoundingClientRect(); if(r.top<12) window.scrollBy(0,r.top-12); }
      }
      var first=plans[0];
      Array.prototype.forEach.call(plans,function(p){
        if(p.hasAttribute('data-plan-default')) first=p;
        if(phone){ p.setAttribute('role','button'); p.setAttribute('tabindex','0'); }
        p.addEventListener('click',function(e){
          if(wide.matches||p.classList.contains('gs-sel')) return;
          e.preventDefault(); pick(p,true);
        });
        p.addEventListener('keydown',function(e){
          if(wide.matches||p.classList.contains('gs-sel')||e.target!==p) return;
          if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(p,true); }
        });
      });
      box.classList.add('gs-plans-on');
      pick(first,false);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* COMPARE (only in the -animated file). Section 11, the comparison table, on phones.
   A wrapper marked data-anim="compare" holds buttons (data-cmp-btn="3", "4", "5": the table column each one shows) and the table (data-cmp-table).
   The script adds gs-cmp-on to the wrapper, which switches the phone layout to the picker (CSS, phones only), marks the chosen button (gs-cmp-cur, aria-pressed)
   and puts gs-cmp-3, gs-cmp-4 or gs-cmp-5 on the table, which decides the column shown next to Growth Serum. It starts on the button that has aria-pressed="true" in the page.
   On desktop the classes have no effect: the buttons are hidden and the whole table shows. Without this script phones show the earlier breakdown of every row.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="compare"]');
    Array.prototype.forEach.call(found,function(box){
      if(box.getAttribute('data-gs-ready')) return;
      var table=box.querySelector('[data-cmp-table]'), btns=box.querySelectorAll('[data-cmp-btn]');
      if(!table||!btns.length) return;
      box.setAttribute('data-gs-ready','1');
      function pick(col){
        Array.prototype.forEach.call(btns,function(b){
          var c=b.getAttribute('data-cmp-btn'), on=c===col;
          b.classList.toggle('gs-cmp-cur',on); b.setAttribute('aria-pressed',on?'true':'false');
          table.classList.toggle('gs-cmp-'+c,on);
        });
      }
      var first=btns[0].getAttribute('data-cmp-btn');
      Array.prototype.forEach.call(btns,function(b){
        if(b.getAttribute('aria-pressed')==='true') first=b.getAttribute('data-cmp-btn');
        b.addEventListener('click',function(){ pick(b.getAttribute('data-cmp-btn')); });
      });
      box.classList.add('gs-cmp-on');
      pick(first);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* TAP SHAKE (only in the -animated file). Section 10, the review cards, and section 14, the gift cards, on phones.
   A tap on an element marked data-tap-shake gives it gs-tap, which plays a short shake (CSS, phones only); the class is taken off again when the shake ends,
   so the next tap shakes it again. A card that is still being shaken in (it has gs-armed but not yet gs-done) ignores the tap.
   On desktop the class has no effect: there the cards shake under the cursor. Without this script a tap simply does nothing.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-tap-shake]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-tap-ready')) return;
      el.setAttribute('data-tap-ready','1');
      el.addEventListener('click',function(){
        if(el.classList.contains('gs-armed')&&!el.classList.contains('gs-done')) return;
        el.classList.remove('gs-tap'); void el.offsetWidth; el.classList.add('gs-tap');
      });
      el.addEventListener('animationend',function(e){ if(e.target===el) el.classList.remove('gs-tap'); });
      el.addEventListener('animationcancel',function(e){ if(e.target===el) el.classList.remove('gs-tap'); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* ARROW (only in the -animated file). Draws a curved arrow from the end of one piece of text to another.
   Mark the start with data-arrow-from="name" and the target with data-arrow-to="name" (same name on both).
   The arrow leaves the end of the start text, swings out to the right and comes in to the right-hand side of the target, pointing at it.
   It is measured from where the two texts really are and redrawn when the window changes size, so it keeps working after a change of wording or language.
   It draws itself in the first time the target has scrolled up to about the middle of the screen, not as soon as it appears,
   so it does not pull the reader away from the section above. Desktop and phones; on phones the swing to the right is smaller, so the arrow stays on the screen.
   Without this script there is just no arrow.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia||!document.createElementNS) return;
  var NS='http://www.w3.org/2000/svg', wide=window.matchMedia('(min-width:861px)'), arrows=[], timer=null, EDGE=12;
  function draw(a){
    if(!document.body.contains(a.from)||!document.body.contains(a.to)) return;
    var host=a.host, hb=host.getBoundingClientRect();
    var fr=a.from.getClientRects(), f=fr[fr.length-1], t=a.to.getBoundingClientRect();
    if(!f||!t.width) return;
    var sx=f.right+12-hb.left, sy=f.top+f.height*0.6-hb.top, ex=t.right+14-hb.left, ey=t.top+t.height*0.55-hb.top;
    var dy=ey-sy, out=Math.max(50,Math.min(110,Math.abs(dy)*0.45));
    /* phones: there is little room beside the text, so the swing to the right is held inside the screen (EDGE px from its right edge) */
    if(!wide.matches) out=Math.max(16,Math.min(out,hb.width-EDGE-Math.max(sx,ex)));
    var c1x=sx+out, c1y=sy+dy*0.25, c2x=Math.max(sx,ex)+out, c2y=ey-dy*0.2;
    var ux=ex-c2x, uy=ey-c2y, ul=Math.sqrt(ux*ux+uy*uy)||1; ux/=ul; uy/=ul;
    function wing(deg){ var r=deg*Math.PI/180, x=ux*Math.cos(r)-uy*Math.sin(r), y=ux*Math.sin(r)+uy*Math.cos(r); return (ex-x*12).toFixed(1)+' '+(ey-y*12).toFixed(1); }
    if(!a.svg){
      a.svg=document.createElementNS(NS,'svg'); a.svg.setAttribute('class','gs-arrow'); a.svg.setAttribute('aria-hidden','true');
      a.line=document.createElementNS(NS,'path'); a.line.setAttribute('class','gs-arrowLine');
      a.head=document.createElementNS(NS,'path'); a.head.setAttribute('class','gs-arrowHead');
      a.svg.appendChild(a.line); a.svg.appendChild(a.head);
    }
    if(a.svg.parentNode!==host) host.appendChild(a.svg);
    a.line.setAttribute('d','M'+sx.toFixed(1)+' '+sy.toFixed(1)+' C'+c1x.toFixed(1)+' '+c1y.toFixed(1)+' '+c2x.toFixed(1)+' '+c2y.toFixed(1)+' '+ex.toFixed(1)+' '+ey.toFixed(1));
    a.head.setAttribute('d','M'+wing(28)+' L'+ex.toFixed(1)+' '+ey.toFixed(1)+' L'+wing(-28));
    try{ a.svg.style.setProperty('--len',Math.ceil(a.line.getTotalLength())+1); }catch(e){}
  }
  function setup(root){
    var froms=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-arrow-from]');
    Array.prototype.forEach.call(document.querySelectorAll('[data-arrow-from]'),function(from){
      if(from.getAttribute('data-gs-ready')) return;
      var name=from.getAttribute('data-arrow-from'), to=document.querySelector('[data-arrow-to="'+name+'"]');
      if(!to) return;
      var host=to.closest?to.closest('section'):null; host=host||to.parentNode;
      from.setAttribute('data-gs-ready','1'); host.classList.add('gs-arrowHost');
      var a={from:from,to:to,host:host,svg:null}; arrows.push(a); draw(a);
      if('IntersectionObserver' in window){
        /* wait until the target has come up to the middle of the screen (the bottom 45% does not count), so the arrow only appears once the reader has clearly moved on to the next section */
        var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting&&a.svg){ a.svg.classList.add('gs-draw'); io.disconnect(); } }); },{threshold:1,rootMargin:'0px 0px -45% 0px'});
        io.observe(to);
      } else if(a.svg) a.svg.classList.add('gs-draw');
    });
  }
  function redraw(){ arrows.forEach(draw); }
  window.addEventListener('resize',function(){ clearTimeout(timer); timer=setTimeout(redraw,150); });
  window.addEventListener('load',redraw);
  if(document.fonts&&document.fonts.ready&&document.fonts.ready.then) document.fonts.ready.then(redraw);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(){ setup(); redraw(); });
})();
;
/* TYPEWRITER (only in the -animated file). Section 19, the P.S.
   Inside a block marked data-anim="type", every piece marked data-type is typed out letter by letter, one piece after another, in the order they stand in the page.
   data-type-wait on a piece is the pause before it starts, in milliseconds: for the first piece counted from the moment the text before it has scrolled into view,
   for each later piece counted from the moment the one before has finished.
   While a piece waits it is invisible but keeps its place, so the page does not jump. Bold and other formatting inside a piece is kept.
   Desktop and phones, and not for visitors with reduced motion. Without this script the text is simply all there.
   On phones the P.S. is too tall to count from "it has scrolled into view", so there the clock starts when the place of the first typed piece
   is where she is reading (its top 58% down the screen or higher and the whole piece above the sticky button bar, the same rule as data-gs-when="watch"),
   and the first pause is the shorter data-type-wait-phone, if the piece has one.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia||!document.createTreeWalker) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var MS_PER_LETTER=34, PAUSE_AFTER_STOP=220;
  /* phones only: shares of the screen height, and the height of the sticky button bar in pixels (the same numbers as in "ANIMATIONS: play when seen") */
  var WATCH=0.58, ZONE_TOP=0.25, BAR=80;
  function typeOut(el,done){
    var walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null,false), nodes=[], n;
    while((n=walker.nextNode())){ if(n.nodeValue.length) nodes.push(n); }
    var parts=nodes.map(function(tn){
      var shown=document.createElement('span'), rest=document.createElement('span');
      rest.style.opacity='0'; rest.textContent=tn.nodeValue;
      tn.parentNode.insertBefore(shown,tn); tn.parentNode.insertBefore(rest,tn); tn.parentNode.removeChild(tn);
      return {shown:shown,rest:rest,full:rest.textContent};
    });
    var caret=document.createElement('span'); caret.className='gs-caret'; caret.setAttribute('aria-hidden','true');
    el.classList.add('gs-typing');
    var pi=0, ci=0;
    function finish(){
      setTimeout(function(){
        if(caret.parentNode) caret.parentNode.removeChild(caret);
        parts.forEach(function(p){ var t=document.createTextNode(p.full); p.shown.parentNode.insertBefore(t,p.shown); p.shown.parentNode.removeChild(p.shown); p.rest.parentNode.removeChild(p.rest); });
        el.classList.add('gs-typed'); el.classList.remove('gs-typing');
      },700);
      if(done) done();
    }
    function tick(){
      if(pi>=parts.length){ finish(); return; }
      var p=parts[pi]; ci++;
      p.shown.textContent=p.full.slice(0,ci); p.rest.textContent=p.full.slice(ci);
      p.rest.parentNode.insertBefore(caret,p.rest);
      /* a short breath after a comma or the end of a sentence, but not inside an abbreviation like "P.P.S." */
      var ch=p.full.charAt(ci-1), nx=p.full.charAt(ci), stop=(ch==='.'||ch===','||ch==='?'||ch==='!')&&(nx===' '||nx==='');
      var wait=MS_PER_LETTER+(stop?PAUSE_AFTER_STOP:0);
      if(ci>=p.full.length){ pi++; ci=0; }
      setTimeout(tick,wait);
    }
    tick();
  }
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="type"]');
    Array.prototype.forEach.call(found,function(block){
      if(block.getAttribute('data-gs-ready')) return;
      var items=Array.prototype.slice.call(block.querySelectorAll('[data-type]')); if(!items.length) return;
      if(calm.matches||!('IntersectionObserver' in window)) return;
      var phone=!wide.matches;
      block.setAttribute('data-gs-ready','1'); block.classList.add('gs-type-on');
      function run(i){
        if(i>=items.length) return;
        var wait=parseInt(items[i].getAttribute('data-type-wait'),10); if(isNaN(wait)) wait=0;
        if(phone&&i===0){ var pw=parseInt(items[i].getAttribute('data-type-wait-phone'),10); if(!isNaN(pw)) wait=pw; }
        setTimeout(function(){ typeOut(items[i],function(){ run(i+1); }); },wait);
      }
      var first=items[0], vh=window.innerHeight||0, io;
      if(phone&&vh>0){
        /* phones: start the clock when the place of the first typed piece has come up to where she is reading */
        var fh=first.offsetHeight, line=Math.max(Math.min(vh*WATCH,vh-BAR-fh),vh*ZONE_TOP);
        io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ io.disconnect(); run(0); } }); },{threshold:0,rootMargin:'0px 0px -'+Math.round(vh-line)+'px 0px'});
        io.observe(first);
        return;
      }
      /* desktop: start the clock when the text just before the first typed piece is on screen */
      var watch=(first.tagName==='P'||!first.closest)?first:(first.closest('p')||first);
      var need=0.6, h=watch.offsetHeight; if(h>0&&vh>0) need=Math.min(need,0.9*vh/h);
      io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting&&e.intersectionRatio>=need-0.01){ io.disconnect(); run(0); } }); },{threshold:need});
      io.observe(watch);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* TEASER (only in the -animated file). Section 4, the "What this means for you?" box, on phones (also sections 9 and 11, and the two folds in the guarantee, section 16).
   A box marked data-anim="teaser" shows only the first lines of its text (data-teaser-body) on screens 860px and narrower.
   A tap on the box or on its button (data-teaser-btn) opens the rest; the button closes it again.
   The script only switches classes (gs-more-on, gs-open, gs-open-done) and tells the CSS how tall the full text is (--gs-more-h), so the slide ends exactly at the text's own height.
   On wider screens it does nothing: the box is open, as it always was. Without this script the box is open on phones too.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="teaser"]');
    Array.prototype.forEach.call(found,function(box){
      if(box.getAttribute('data-gs-ready')) return;
      var body=box.querySelector('[data-teaser-body]'), btn=box.querySelector('[data-teaser-btn]');
      if(!body||!btn) return;
      box.setAttribute('data-gs-ready','1'); box.classList.add('gs-more-on');
      function set(open){
        if(wide.matches) return;
        box.style.setProperty('--gs-more-h',body.scrollHeight+'px');
        box.classList.remove('gs-open-done');
        void body.offsetHeight;
        box.classList.toggle('gs-open',open);
        btn.setAttribute('aria-expanded',open?'true':'false');
        if(open&&calm.matches) box.classList.add('gs-open-done');
      }
      /* once it has slid open the height limit is taken off, so the text can never be cut if the screen is turned */
      body.addEventListener('transitionend',function(e){ if(e.target===body&&e.propertyName==='max-height'&&box.classList.contains('gs-open')) box.classList.add('gs-open-done'); });
      btn.addEventListener('click',function(e){ e.stopPropagation(); set(!box.classList.contains('gs-open')); });
      box.addEventListener('click',function(){ if(!box.classList.contains('gs-open')) set(true); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* STAGES (only in the -animated file). Section 8, the three microcamera photos, on screens 860px and narrower.
   A row marked data-anim="stages" holds cards marked data-stage; each card has a photo and a name (data-stage-tab).
   On a phone the row becomes one large photo that moves through the stages (the layout and the fade are CSS, see "8 the study photos ON PHONES").
   The script switches classes: gs-st-on on the row (the large-photo layout), gs-st-in on every card up to the current one (photo shown),
   gs-st-cur on the current card (its name is highlighted), gs-st-run on the row while it moves on by itself, gs-st-held once the visitor has tapped.
   It also tells the CSS how long the current photo stays (--gs-st-ms, read from data-stage-ms on the card; 2400 if missing)
   and makes the names work as buttons (role, tabindex, aria-pressed; Enter and Space work too).
   It starts when the frame is where she is reading: its top edge 58% down the screen or higher, and the whole frame above the sticky button bar
   (the same "watch" line as elsewhere, see Knowledge/viewport_gaze_hot_zones_by_device.svg). It pauses while the frame is off screen.
   LOOP below: true = after the last photo it starts again from the first; false = it stops on the last photo.
   A tap on a name shows that photo; a tap on the photo shows the next one. Either pauses the automatic run: after RESUME ms (8 seconds) with no
   further tap it carries on from the photo she picked (v6, 15 Oct 2026). Each new tap restarts the 8 seconds.
   Not on wider screens and not for visitors with reduced motion. Without this script the three photos stand side by side.
   The width is checked live, not only when the page loads (v8, 15 Oct 2026): Shopify's theme editor and some phones first lay the page out wider
   and narrow it a moment later, which used to leave the three small photos in place until a refresh. Crossing 860px now switches the layout either way.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var LOOP=true, RESUME=8000, WATCH=0.58, ZONE_TOP=0.25, BAR=80;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var rows=[];
  function phone(){ return !wide.matches&&!calm.matches; }
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="stages"]');
    Array.prototype.forEach.call(found,function(row){
      if(row.getAttribute('data-gs-ready')) return;
      var cards=row.querySelectorAll('[data-stage]'), n=cards.length;
      if(n<2) return;
      row.setAttribute('data-gs-ready','1');
      var cur=0, timer=null, held=false, started=false, inView=true, resume=null, active=false, first=null, seen=null;
      function show(i){
        cur=i;
        Array.prototype.forEach.call(cards,function(c,k){
          c.classList.toggle('gs-st-in',k<=i); c.classList.toggle('gs-st-cur',k===i);
          var t=c.querySelector('[data-stage-tab]'); if(t) t.setAttribute('aria-pressed',k===i?'true':'false');
        });
      }
      function stay(){ var ms=parseInt(cards[cur].getAttribute('data-stage-ms'),10); return ms>0?ms:2400; }
      function stop(){ clearTimeout(timer); timer=null; row.classList.remove('gs-st-run'); }
      function run(){
        stop();
        if(!active||held||!started||!inView) return;
        if(!LOOP&&cur===n-1) return;
        row.style.setProperty('--gs-st-ms',stay()+'ms');
        void row.offsetWidth;
        row.classList.add('gs-st-run');
        timer=setTimeout(function(){ show((cur+1)%n); run(); },stay());
      }
      function pick(i){
        if(!active) return;
        held=true; stop(); row.classList.add('gs-st-held'); show(i);
        clearTimeout(resume);
        resume=setTimeout(function(){ held=false; row.classList.remove('gs-st-held'); run(); },RESUME);
      }
      Array.prototype.forEach.call(cards,function(c,k){
        var t=c.querySelector('[data-stage-tab]'), ph=c.querySelector('.ph');
        if(t){
          t.addEventListener('click',function(){ pick(k); });
          t.addEventListener('keydown',function(e){ if(active&&(e.key==='Enter'||e.key===' ')){ e.preventDefault(); pick(k); } });
        }
        if(ph) ph.addEventListener('click',function(){ pick((cur+1)%n); });
      });
      function on(){
        if(active) return; active=true;
        Array.prototype.forEach.call(cards,function(c){ var t=c.querySelector('[data-stage-tab]'); if(t){ t.setAttribute('role','button'); t.setAttribute('tabindex','0'); } });
        row.classList.add('gs-st-on');
        show(cur);
        if(!('IntersectionObserver' in window)){ started=true; run(); return; }
        if(!started){
          var h=row.offsetHeight, vh=window.innerHeight||0, line=vh*WATCH;
          if(h>0) line=Math.max(Math.min(line,vh-BAR-h),vh*ZONE_TOP);
          first=new IntersectionObserver(function(es){
            es.forEach(function(e){ if(e.isIntersecting){ started=true; first.disconnect(); run(); } });
          },{threshold:0,rootMargin:'0px 0px -'+Math.round(vh-line)+'px 0px'});
          first.observe(row);
        }
        if(!seen){ seen=new IntersectionObserver(function(es){ es.forEach(function(e){ inView=e.isIntersecting; if(inView) run(); else stop(); }); },{threshold:0}); seen.observe(row); }
        run();
      }
      function off(){
        if(!active) return; active=false;
        stop(); clearTimeout(resume); held=false;
        if(first){ first.disconnect(); first=null; }
        row.classList.remove('gs-st-on','gs-st-held');
        Array.prototype.forEach.call(cards,function(c){
          c.classList.remove('gs-st-in','gs-st-cur');
          var t=c.querySelector('[data-stage-tab]'); if(t){ t.removeAttribute('role'); t.removeAttribute('tabindex'); t.removeAttribute('aria-pressed'); }
        });
      }
      rows.push({on:on,off:off,row:row});
      if(phone()) on();
    });
  }
  function sync(){ rows=rows.filter(function(r){ return document.contains(r.row); }); rows.forEach(function(r){ if(phone()) r.on(); else r.off(); }); }
  if(wide.addEventListener){ wide.addEventListener('change',sync); calm.addEventListener('change',sync); } else if(wide.addListener){ wide.addListener(sync); calm.addListener(sync); }
  window.addEventListener('resize',sync);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* CYCLE ON PHONES (only in the -animated file). Section 4, how hair grows, on screens 860px and narrower.
   The small gold arrows between the three cards, the two curved arrows under card 3 and the handwritten note between them follow the scroll, in both directions.
   Two lines across the screen decide how far a piece is drawn: it starts when its top edge comes up past the lower line and is complete
   when it reaches the upper line (START and END below, as a share of the screen height: 0.5 is the middle of the screen).
   Both lines sit at the lower edge of the zone the eye rests in on a phone (25% to 50% of the screen height, see Knowledge/viewport_gaze_hot_zones_by_device.svg).
   So the arrow out of a card sets off when the bottom edge of that card passes the middle of the screen, and is complete a little above it
   (the distance between the two lines is how much scrolling a piece takes: 5% of the screen height, about 45px on a phone).
   The script switches the pieces on (gs-cy-on), tells each line how far it is drawn (--gs-p, 0 to 1), marks a card whose arrow has arrived (gs-hit,
   which makes its number badge pulse) and the note whose arrow has arrived (gs-on, which makes the words pop in). Scrolling back takes all of it back.
   Not on wider screens and not for visitors with reduced motion. Without this script the three cards are simply there, with no arrows and no note.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.requestAnimationFrame||!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var START=0.5, END=0.45;
  var rows=[], queued=false;
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="cycle"]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-cy-ready')) return;
      var cards=el.querySelectorAll('[data-cy-step]'); if(!cards.length) return;
      el.setAttribute('data-cy-ready','1');
      var host=el.closest?el.closest('section'):null, note=(host||document).querySelector('[data-cy-note]');
      rows.push({el:el,cards:cards,note:note,noteB:note?note.querySelector('[data-cy-note-b]'):null});
    });
    ask();
  }
  function share(y,a,b){ return Math.max(0,Math.min(1,(a-y)/(a-b))); }
  function mark(el,on,off){ if(on) el.classList.add('gs-hit'); else if(off) el.classList.remove('gs-hit'); }
  function update(){
    queued=false;
    var on=!wide.matches&&!calm.matches, vh=window.innerHeight, a=vh*START, b=vh*END;
    rows.forEach(function(r){
      if(!document.body.contains(r.el)) return;
      r.el.classList.toggle('gs-cy-on',on); if(r.note) r.note.classList.toggle('gs-cy-on',on);
      if(!on) return;
      var box=r.el.getBoundingClientRect();
      if(box.bottom<-500||box.top>vh+500) return;
      var i, n=r.cards.length, prev=null, cr, p, link;
      for(i=0;i<n;i++){
        cr=r.cards[i].getBoundingClientRect();
        if(i===0){ mark(r.cards[i],cr.top<a,cr.top>a+80); }
        else{
          p=share(prev.bottom,a,b);
          link=r.cards[i].querySelector('[data-cy-link]'); if(link) link.style.setProperty('--gs-p',p.toFixed(3));
          mark(r.cards[i],p>=1,p<0.5);
        }
        prev=cr;
      }
      if(r.note){
        p=share(prev.bottom,a,b);
        r.note.style.setProperty('--gs-p',p.toFixed(3));
        r.note.classList.toggle('gs-on',p>=1);
        /* the arrow back up only sets off once the words are there, and takes as much scrolling again as the arrow in */
        if(r.noteB) r.noteB.style.setProperty('--gs-p',Math.max(0,Math.min(1,(a-prev.bottom)/(a-b)-1.15)).toFixed(3));
      }
    });
  }
  function ask(){ if(!queued){ queued=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll',ask,{passive:true});
  window.addEventListener('resize',ask);
  window.addEventListener('load',ask);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* CYCLE LOOP (desktop only, 9 Oct 2026). Section 4. Draws the gold loop as one SVG path: out of the right side of card 1, under cards 2 and 3,
   out of card 3, up, back above the cards, down on the left and into card 1, with an arrowhead. Badge 1 pulses, then the line fades out.
   First run, as in the original: card 1 rises in, then the line sets off and each next card rises in the moment the line reaches it.
   The line is masked out where the cards are, so it only ever shows in the gaps and around the outside.
   After that the line alone runs again PAUSE milliseconds after it has faded, while the cards are on screen.
   Phones, reduced motion, a background tab or the section off screen: it waits. DRAW is the time for the whole loop in ms. */
(function(){
  var row=document.querySelector('[data-anim="cycle"]'); if(!row||!window.matchMedia||!row.animate) return;
  var mq=window.matchMedia('(min-width:861px) and (prefers-reduced-motion:no-preference)');
  var DRAW=3000, CARD1=500, HOLD=600, FADE=500, PAUSE=5000;
  var UP=37, OUT=20, R=12, NS='http://www.w3.org/2000/svg';
  var cards=row.querySelectorAll('[data-cy-step]'), badge=cards[0]&&cards[0].querySelector('.num');
  if(cards.length<3) return;
  if(mq.matches) row.classList.add('gs-js-loop');
  var svg=document.createElementNS(NS,'svg'), defs=document.createElementNS(NS,'defs'), mask=document.createElementNS(NS,'mask'),
      bg=document.createElementNS(NS,'rect'), path=document.createElementNS(NS,'path'), head=document.createElementNS(NS,'polygon'), holes=[];
  var mid='gs-cy-mask-'+Math.random().toString(36).slice(2,7);
  mask.setAttribute('id',mid); mask.setAttribute('maskUnits','userSpaceOnUse'); bg.setAttribute('fill','#fff'); mask.appendChild(bg);
  for(var i=0;i<3;i++){ var h=document.createElementNS(NS,'rect'); h.setAttribute('fill','#000'); mask.appendChild(h); holes.push(h); }
  defs.appendChild(mask); svg.appendChild(defs); path.setAttribute('mask','url(#'+mid+')'); svg.appendChild(path); svg.appendChild(head);
  svg.setAttribute('class','gs-cyLoop'); svg.setAttribute('aria-hidden','true'); row.insertBefore(svg,row.firstChild);
  var len=0, marks=[], visible=true, running=false, started=false, first=true, timer=null;
  function build(){
    var W=row.clientWidth, H=cards[0].offsetHeight, x1=cards[0].offsetLeft+cards[0].offsetWidth, M=Math.round(H/2), T=-UP;
    svg.setAttribute('width',W); svg.setAttribute('height',H); svg.setAttribute('viewBox','0 0 '+W+' '+H);
    bg.setAttribute('x',-60); bg.setAttribute('y',-80); bg.setAttribute('width',W+120); bg.setAttribute('height',H+160);
    mask.setAttribute('x',-60); mask.setAttribute('y',-80); mask.setAttribute('width',W+120); mask.setAttribute('height',H+160);   /* the default mask area is too small and would cut off the run above the cards */
    for(var i=0;i<3;i++){ var c=cards[i]; holes[i].setAttribute('x',c.offsetLeft); holes[i].setAttribute('y',c.offsetTop); holes[i].setAttribute('width',c.offsetWidth); holes[i].setAttribute('height',c.offsetHeight); }
    var d='M'+x1+' '+M+' H'+(W+OUT-R)+' a'+R+' '+R+' 0 0 0 '+R+' '+(-R)+' V'+(T+R)+' a'+R+' '+R+' 0 0 0 '+(-R)+' '+(-R)+
          ' H'+(-OUT+R)+' a'+R+' '+R+' 0 0 0 '+(-R)+' '+R+' V'+(M-R)+' a'+R+' '+R+' 0 0 0 '+R+' '+R+' H-6';
    path.setAttribute('d',d); head.setAttribute('points','0,'+M+' -8,'+(M-5)+' -8,'+(M+5));
    len=Math.ceil(path.getTotalLength())+2; path.style.strokeDasharray=len;
    marks=[cards[1].offsetLeft-x1, cards[2].offsetLeft-x1];   /* where the line reaches card 2 and card 3 */
    if(!running) path.style.strokeDashoffset=len;
  }
  function ease(t){ var q=t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2; return .55*t+.45*q; }
  function draw(done){
    var t0=null, next=0;
    function frame(now){
      if(t0===null) t0=now;
      var t=Math.min(1,(now-t0)/DRAW), dist=ease(t)*len;
      path.style.strokeDashoffset=(len-dist).toFixed(1);
      while(first&&next<marks.length&&dist>=marks[next]-2){ cards[next+1].classList.add('gs-in'); next++; }
      if(t<1) requestAnimationFrame(frame); else done();
    }
    requestAnimationFrame(frame);
  }
  function run(){
    running=true; build(); svg.style.opacity=1;
    draw(function(){
      head.animate([{opacity:0},{opacity:1}],{duration:150,fill:'forwards'});
      if(badge) badge.animate([{transform:'scale(1)'},{transform:'scale(1.2)',offset:.45},{transform:'scale(1)'}],{duration:500,easing:'ease-in-out'});
      first=false;
      setTimeout(function(){
        var fade=svg.animate([{opacity:1},{opacity:0}],{duration:FADE,easing:'ease-in',fill:'forwards'});
        fade.onfinish=function(){ svg.style.opacity=0; fade.cancel(); head.getAnimations().forEach(function(a){a.cancel();}); path.style.strokeDashoffset=len; running=false; later(PAUSE); };
      },HOLD);
    });
  }
  function tick(){ if(mq.matches&&visible&&!document.hidden) run(); else later(1000); }
  function later(ms){ clearTimeout(timer); timer=setTimeout(tick,ms); }
  function start(){
    if(started) return; started=true;
    if(!mq.matches) return;
    cards[0].classList.add('gs-in'); setTimeout(run,CARD1);
  }
  if('IntersectionObserver' in window) new IntersectionObserver(function(es){ visible=es[es.length-1].isIntersecting; }).observe(row);
  if(window.ResizeObserver) new ResizeObserver(function(){ if(mq.matches) build(); }).observe(row); else window.addEventListener('resize',build);
  if(mq.matches) build();
  if(row.classList.contains('gs-play')) start();
  else new MutationObserver(function(m,o){ if(row.classList.contains('gs-play')){ o.disconnect(); start(); } }).observe(row,{attributes:true,attributeFilter:['class']});
})();
;
/* THINK: section 2 thought bubbles. Hides each bubble once the script runs and pops it in once when its top is above 70% of the screen. Exits quietly if none exist. */
(function(){
  function setup(root){
    var els=(root||document).querySelectorAll('[data-anim="think"]');
    if(!els.length||!('IntersectionObserver' in window)) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('gs-shown'); io.unobserve(e.target); } });
    },{rootMargin:'0px 0px -30% 0px'});
    els.forEach(function(el){ if(el.dataset.gsThink) return; el.dataset.gsThink='1'; el.classList.add('gs-armed'); io.observe(el); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){setup();}); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* FLIP: section 3 guess cards turn over on click, tap, Enter or Space. Turning one over turns any other open card back. Exits quietly if there are none. */
(function(){
  function setup(root){
    (root||document).querySelectorAll('[data-flip]').forEach(function(el){
      if(el.dataset.gsFlip) return; el.dataset.gsFlip='1'; el.classList.add('gs-flip-on');
      function t(){ if(el.classList.contains('gs-peek')){ el.classList.remove('gs-peek'); void el.offsetWidth; } /* a tap during the peek used to jump to the back with no turn (Lan, 26 Oct) */
        var on=!el.classList.contains('is-flipped'); var grp=el.closest('.gs-guesses')||document;
        if(on) grp.querySelectorAll('[data-flip].is-flipped').forEach(function(o){ if(o!==el){ o.classList.remove('is-flipped'); o.setAttribute('aria-pressed','false'); } });
        el.classList.toggle('is-flipped',on); el.setAttribute('aria-pressed',on?'true':'false'); } /* only one card turned over at a time (Lan, 14 Oct) */
      el.addEventListener('click',t);
      el.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); t(); } });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){setup();}); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* GIFT FLIP (v7, 15 Oct 2026). Phones: each tile in the gifts grid turns over on a tap or Enter/Space, and back again.
   Hook: data-gt-flip on the tile; the class gs-gt-on shows the back. The tile is a button for screen readers (aria-pressed). */
(function(){
  function setup(root){
    Array.prototype.forEach.call((root||document).querySelectorAll('[data-gt-flip]'),function(t){
      if(t.getAttribute('data-gs-ready')) return; t.setAttribute('data-gs-ready','1');
      var front=t.querySelector('.gs-gtFront'), back=t.querySelector('.gs-gtBack');
      function flip(){ var on=!t.classList.contains('gs-gt-on'); t.classList.toggle('gs-gt-on',on); t.setAttribute('aria-pressed',on?'true':'false');
        if(front) front.setAttribute('aria-hidden',on?'true':'false'); if(back) back.setAttribute('aria-hidden',on?'false':'true'); }
      t.addEventListener('click',flip);
      t.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); flip(); } });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* GIFT NUDGE (v8, 15 Oct 2026). Phones: while the gifts grid is on screen, every 6 seconds one tile shakes (class gs-gt-nudge for half a second),
   in the order 2, 3, 1, 4 and round again; turned-over tiles are skipped. The first shake comes 1.5 seconds after the grid comes into view.
   It stops while the grid is off screen and carries on where it left off. Not on wider screens and not with reduced motion; both are checked at every
   shake, not once at load, so it also works when a desktop window is narrowed to phone width (or Chrome is switched to phone view) without reloading. */
(function(){
  if(!window.matchMedia||!('IntersectionObserver' in window)) return;
  var EVERY=6000, FIRST=1500, ORDER=[1,2,0,3];
  function quiet(){ return window.matchMedia('(min-width:861px)').matches||window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function setup(root){
    Array.prototype.forEach.call((root||document).querySelectorAll('.gs-giftGrid'),function(grid){
      if(grid.getAttribute('data-gs-nudge')) return; grid.setAttribute('data-gs-nudge','1');
      var tiles=grid.querySelectorAll('.gs-giftTile'), step=0, timer=null;
      if(tiles.length<2) return;
      function nudge(){
        if(quiet()){ timer=setTimeout(nudge,EVERY); return; }
        for(var tries=0;tries<ORDER.length;tries++){
          var t=tiles[ORDER[step%ORDER.length]]; step++;
          if(t&&!t.classList.contains('gs-gt-on')){
            t.classList.remove('gs-gt-nudge'); void t.offsetWidth; t.classList.add('gs-gt-nudge');
            setTimeout(function(x){ return function(){ x.classList.remove('gs-gt-nudge'); }; }(t),600);
            break;
          }
        }
        timer=setTimeout(nudge,EVERY);
      }
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          clearTimeout(timer); timer=null;
          if(e.isIntersecting) timer=setTimeout(nudge,FIRST);
        });
      },{threshold:0.5}).observe(grid);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* VIDEO TILES (v8, 15 Oct 2026). Section 10.
   1. Every tile's video (also the copies the VIDEO STRIP script makes) plays muted and on a loop while it is on screen, and pauses when it leaves.
      preload="none" plus a cover image, so nothing downloads until a tile is actually seen.
   2. A tap (or Enter / Space) on a tile opens its video large, with sound and controls; the strip holds still (class gs-hold) until it is closed
      with the X, a tap outside the video, or Escape. Closing returns focus to the tile.
   With reduced motion the tiles do not play by themselves; the player still works. It stands alone and runs again when the theme editor reloads a section. */
(function(){
  var calm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){ var v=e.target; if(e.isIntersecting&&!calm){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else v.pause(); });
  },{threshold:0.25}):null;
  function watch(root){
    Array.prototype.forEach.call((root||document).querySelectorAll('.gs-vidT video'),function(v){
      if(v.getAttribute('data-gs-watched')) return; v.setAttribute('data-gs-watched','1'); v.muted=true;
      if(io) io.observe(v);
    });
  }
  function setup(root){
    watch(root);
    Array.prototype.forEach.call((root||document).querySelectorAll('[data-mq-track]'),function(t){
      if(t.getAttribute('data-gs-vwatch')) return; t.setAttribute('data-gs-vwatch','1');
      if('MutationObserver' in window) new MutationObserver(function(){ watch(t); }).observe(t,{childList:true});
    });
  }
  var open=null;
  function close(){
    if(!open) return; var o=open; open=null;
    o.box.classList.remove('gs-on'); o.v.pause();
    if(o.strip) o.strip.classList.remove('gs-hold');
    setTimeout(function(){ if(o.box.parentNode) o.box.parentNode.removeChild(o.box); },220);
    document.removeEventListener('keydown',key,true);
    if(o.from&&o.from.focus) o.from.focus({preventScroll:true});
  }
  function key(e){ if(e.key==='Escape'){ e.preventDefault(); close(); } }
  function play(tile){
    var src=tile.getAttribute('data-gs-video'); if(!src) return;
    close();
    var box=document.createElement('div'); box.className='gs-vplay'; box.setAttribute('role','dialog'); box.setAttribute('aria-modal','true');
    box.setAttribute('aria-label',(tile.getAttribute('aria-label')||'Video').replace(/^Watch with sound: /,''));
    var v=document.createElement('video'); v.src=src; v.controls=true; v.playsInline=true; v.setAttribute('playsinline','');
    var small=tile.querySelector('video'); if(small&&small.getAttribute('poster')) v.poster=small.getAttribute('poster');
    var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Close'); b.textContent='×';
    box.appendChild(v); box.appendChild(b); document.body.appendChild(box);
    var strip=tile.closest('.gs-mq'); if(strip) strip.classList.add('gs-hold');
    open={box:box,v:v,strip:strip,from:tile.hasAttribute('data-mq-clone')?null:tile};
    box.addEventListener('click',function(e){ if(e.target===box) close(); });
    b.addEventListener('click',close);
    document.addEventListener('keydown',key,true);
    requestAnimationFrame(function(){ box.classList.add('gs-on'); });
    var p=v.play(); if(p&&p.catch) p.catch(function(){});
    b.focus();
  }
  document.addEventListener('click',function(e){ var t=e.target.closest&&e.target.closest('.gs-vidT'); if(t){ e.preventDefault(); play(t); } });
  document.addEventListener('keydown',function(e){ if((e.key==='Enter'||e.key===' ')&&e.target.classList&&e.target.classList.contains('gs-vidT')){ e.preventDefault(); play(e.target); } });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  window.addEventListener('load',function(){ setup(); });
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* READING LINE (v8, 15 Oct 2026). Draws the line (styles: "READING LINE") and keeps its length equal to how far down the page she has scrolled:
   empty at the top, full at the bottom. The line sits right under the header while the header is on screen (the SKINFAIRYTALE bar here, the store's
   header on Shopify, which slides away when she scrolls down and comes back when she scrolls up), and at the very top of the screen when it is not.
   While she scrolls, and for half a second after, it is updated every frame so it follows the header as it slides. It stands alone and adds the line only once. */
(function(){
  if(document.querySelector('.gs-readbar')) return;
  var wrap=document.createElement('div'); wrap.className='gs-readbar'; wrap.setAttribute('aria-hidden','true');
  var bar=document.createElement('i'); wrap.appendChild(bar);
  var head=null, until=0, running=false, lastTop=-1;
  function findHead(){ return document.querySelector('.gs-topbar')||document.querySelector('.page-header')||document.querySelector('#shopify-section-header')||document.querySelector('header'); }
  function update(){
    var h=document.documentElement, max=h.scrollHeight-window.innerHeight;
    var r=max>0?Math.min(1,Math.max(0,(window.scrollY||h.scrollTop)/max)):0;
    bar.style.transform='scaleX('+r.toFixed(4)+')';
    if(!head||!document.contains(head)) head=findHead();
    var top=0;
    if(head){ var b=head.getBoundingClientRect(); if(b.bottom>0&&b.top<window.innerHeight) top=Math.round(b.bottom); }
    if(top!==lastTop){ wrap.style.top=top+'px'; lastTop=top; }
  }
  function loop(){ update(); if(performance.now()<until) requestAnimationFrame(loop); else running=false; }
  function kick(){ update(); until=performance.now()+500; if(!running){ running=true; requestAnimationFrame(loop); } }
  function add(){ document.body.appendChild(wrap); kick(); }
  window.addEventListener('scroll',kick,{passive:true});
  window.addEventListener('resize',kick);
  window.addEventListener('load',kick);
  if(document.body) add(); else document.addEventListener('DOMContentLoaded',add);
})();
;
/* STUDY BASELINE POSITION (v8, 15 Oct 2026). Puts the dashed baseline (styles: "STUDY BASELINE") exactly level with the top of the full-height Start bar:
   its distance from the bottom of the chart = the space under the bars (the names, whose height depends on the font) + the Start bar's height from its style.
   It also keeps the word "Baseline" centred over the Start bar, which moves when the bars are centred on phones.
   Runs on load, when the fonts are ready and on resize; without it the line uses the 112px from the styles. */
(function(){
  function place(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-anim="bars"]'),function(c){
      var line=c.querySelector('.gs-baseline'), b1=c.querySelector('[data-bar="1"]'); if(!line||!b1) return;
      var h=parseFloat(b1.style.height)||0; if(!h) return;
      var gap=c.getBoundingClientRect().bottom-b1.getBoundingClientRect().bottom;
      line.style.bottom=Math.round(gap+h)+'px';
      var bars=c.querySelectorAll('[data-bar]'), last=bars[bars.length-1], cb=c.getBoundingClientRect();
      var over=14; /* the line sticks out the same amount on both sides of the bars (21 Oct 2026) */
      line.style.left=Math.round(b1.getBoundingClientRect().left-cb.left-over)+'px';
      line.style.right=Math.round(cb.right-last.getBoundingClientRect().right-over)+'px';
      var word=line.querySelector('span'); if(word){ var lb=line.getBoundingClientRect(), bb=b1.getBoundingClientRect(); word.style.left=Math.round(bb.left-lb.left)+'px'; word.style.width=Math.round(bb.width)+'px'; }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',place); else place();
  window.addEventListener('load',place); window.addEventListener('resize',place);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(place);
  document.addEventListener('shopify:section:load',place);
})();

;
/* FLIP CARDS, SHORT WITH A PLUS (16 Oct 2026, phones and desktop): each card is only as tall as its front; on desktop the cards in a row
   share the height of the tallest front. Turned over, the back shows what fits with a fade and a round plus button at the bottom; the plus
   opens the whole answer (the card grows smoothly), the minus closes it again, and turning the card back or turning another card closes it.
   The plus never turns the card. The script sets classes (gs-fm on the card, gs-fm-open when opened) and the height (--gs-bh). */
(function(){
  function setup(root){
    (root||document).querySelectorAll('.gs-guesses').forEach(function(grid){
      if(grid.getAttribute('data-gs-fm')) return;
      var cards=[].slice.call(grid.querySelectorAll('[data-flip]')).filter(function(c){ return c.querySelector('.gs-front')&&c.querySelector('.gs-back'); });
      if(!cards.length) return;
      grid.setAttribute('data-gs-fm','1');
      function sizeAll(){
        var rows={};
        cards.forEach(function(c){ c.classList.add('gs-fm'); var top=Math.round(c.parentElement.getBoundingClientRect().top+window.scrollY); (rows[top]=rows[top]||[]).push(c); });
        Object.keys(rows).forEach(function(k){
          var row=rows[k], h=0;
          row.forEach(function(c){ var f=c.querySelector('.gs-front'); f.style.height='auto'; h=Math.max(h,f.offsetHeight); f.style.height=''; });
          row.forEach(function(c){
            var back=c.querySelector('.gs-back'), open=c.classList.contains('gs-fm-open')&&c.classList.contains('is-flipped');
            var v=open?Math.max(h,back.scrollHeight):h;
            if(v>0) c.style.setProperty('--gs-bh',v+'px');
          });
        });
      }
      cards.forEach(function(card){
        var back=card.querySelector('.gs-back');
        var btn=document.createElement('button');
        btn.type='button'; btn.className='gs-flipMore'; btn.setAttribute('aria-expanded','false'); btn.setAttribute('aria-label','Show the whole answer');
        back.appendChild(btn);
        function setOpen(o){
          card.classList.toggle('gs-fm-open',o);
          btn.setAttribute('aria-expanded',o?'true':'false');
          btn.setAttribute('aria-label',o?'Show less':'Show the whole answer');
          sizeAll();
        }
        btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); setOpen(!card.classList.contains('gs-fm-open')); });
        btn.addEventListener('keydown',function(e){ e.stopPropagation(); });
        new MutationObserver(function(){ if(!card.classList.contains('is-flipped')&&card.classList.contains('gs-fm-open')) setOpen(false); }).observe(card,{attributes:true,attributeFilter:['class']});
        if('ResizeObserver' in window) new ResizeObserver(function(){ sizeAll(); }).observe(card.querySelector('.gs-front'));
      });
      window.addEventListener('resize',sizeAll);
      if(document.fonts&&document.fonts.ready) document.fonts.ready.then(sizeAll);
      sizeAll();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();

;
/* FLIP CARD PEEK (16 Oct 2026): each flip card shows once that it turns. When a card comes on screen it turns about 24 degrees and
   springs back (CSS gsPeek), one card after the other when several are on screen. Once per card per page view; never on a card that is already turned;
   not for visitors with reduced motion. The script only adds the class gs-peek and removes it when the movement ends.
   After the peeks it adds gs-turnPlay to the row: the TURN OVER labels then shake one after the other, rest 5 s after the last one, and repeat. */
(function(){
  if(!('IntersectionObserver' in window)||!window.matchMedia) return;
  var calm=window.matchMedia('(prefers-reduced-motion: reduce)'), wide=window.matchMedia('(min-width:861px)');
  function setup(root){
    (root||document).querySelectorAll('.gs-guesses').forEach(function(grid){
      if(grid.getAttribute('data-gs-peek')) return; grid.setAttribute('data-gs-peek','1');
      var cards=[].slice.call(grid.querySelectorAll('[data-flip]'));
      var next=0;
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return;
          var c=e.target, i=cards.indexOf(c); io.unobserve(c);
          if(calm.matches) return;
          setTimeout(function(){
            if(c.classList.contains('is-flipped')) return;
            c.classList.add('gs-peek');
            c.addEventListener('animationend',function done(ev){ if(ev.animationName==='gsPeek'){ c.classList.remove('gs-peek'); c.removeEventListener('animationend',done); } });
          }, (function(){ var now=Date.now(), at=Math.max(now+(wide.matches?700:500), next+260); next=at; return at-now; })());
        });
      },{threshold:0.7});
      cards.forEach(function(c){ io.observe(c); });
      /* TURN OVER shake: once the cards are on screen and have peeked, the TURN OVER labels shake one after the other, then 5 s of rest (CSS gsTurnShake, 6.6 s cycle) */
      var io2=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ io2.disconnect(); if(!calm.matches) setTimeout(function(){ grid.classList.add('gs-turnPlay'); },2600); } }); },{threshold:0.35});
      io2.observe(grid);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();

;
/* GIFT FOLD (16 Oct 2026, phones): in each plan of the selector the FREE GIFTS list (heading, gift rows, free shipping line) folds into one row:
   the heading, the gift photos side by side and an arrow. A tap opens the full list as before; the arrow turns up and closes it.
   The total gift value line stays visible under it. On screens wider than 860px nothing changes (the CSS shows the full list).
   The script only wraps the existing elements (gs-giftFold) and adds the row (gs-giftSum); every text stays editable in the editor. */
(function(){
  function setup(root){
    (root||document).querySelectorAll('[data-plan-more]').forEach(function(more){
      if(more.getAttribute('data-gs-gfold')) return;
      var rows=[].slice.call(more.querySelectorAll(':scope > .gs-giftRow'));
      if(!rows.length) return;
      more.setAttribute('data-gs-gfold','1');
      var head=rows[0].previousElementSibling, last=rows[rows.length-1], ship=last.nextElementSibling;
      if(ship&&!(ship.classList.contains('gs-planLine')&&!ship.classList.contains('gs-total'))) ship=null;
      var fold=document.createElement('div'); fold.className='gs-giftFold';
      more.insertBefore(fold,head||rows[0]);
      if(head){ head.classList.add('gs-gfHead'); fold.appendChild(head); }
      rows.forEach(function(r){ fold.appendChild(r); });
      if(ship) fold.appendChild(ship);
      var btn=document.createElement('button'); btn.type='button'; btn.className='gs-giftSum'; btn.setAttribute('aria-expanded','false');
      var lab=document.createElement('span'); lab.className='gs-gsLabel'; lab.textContent=head?head.textContent.trim():'';
      var th=document.createElement('span'); th.className='gs-gsThumbs';
      rows.forEach(function(r){ var t=r.querySelector('.gs-th'); if(t) th.appendChild(t.cloneNode(true)); });
      /* load the photos straight away: lazy photos inside a closed fold are not loaded by some phones (Safari) when it opens */
      [].forEach.call(more.querySelectorAll('.gs-th img'),function(im){ if(im.loading==='lazy'){ im.loading='eager'; if(!im.complete){ var s=im.src; im.src=''; im.src=s; } } });
      var ch=document.createElement('span'); ch.className='gs-gsChev'; ch.setAttribute('aria-hidden','true');
      btn.appendChild(lab); btn.appendChild(th); btn.appendChild(ch);
      btn.setAttribute('aria-label',(lab.textContent||'Gifts')+': show the list');
      more.insertBefore(btn,fold);
      function set(o){
        fold.style.setProperty('--gs-gf-h',fold.scrollHeight+'px');
        void fold.offsetHeight;
        more.classList.toggle('gs-gf-open',o);
        btn.setAttribute('aria-expanded',o?'true':'false');
        btn.setAttribute('aria-label',(lab.textContent||'Gifts')+(o?': hide the list':': show the list'));
      }
      btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); set(!more.classList.contains('gs-gf-open')); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();

;
/* PER-DAY LINE BREAK (16 Oct 2026, phones): in the selected plan the line "1,09 € a day · one-time payment" breaks before its last word,
   so "… · one-time" is the first line and "payment" the second in every plan. The break is a <br class="gs-pdBr"> that the CSS only shows
   in the selected plan on screens 860px and narrower. Only lines with "·" and at least two words after it get one. */
(function(){
  function setup(root){
    (root||document).querySelectorAll('[data-plan-day]').forEach(function(el){
      if(el.querySelector('.gs-pdBr')) return;
      var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null), n, last=null;
      while((n=w.nextNode())){ if(/\S/.test(n.nodeValue)) last=n; }
      if(!last) return;
      var full=el.textContent, dot=full.lastIndexOf('·'); if(dot<0) return;
      var after=full.slice(dot+1).trim().split(/\s+/); if(after.length<2) return;
      var v=last.nodeValue.replace(/\s+$/,''), i=v.lastIndexOf(' '); if(i<0) return;
      var rest=last.splitText(i); rest.nodeValue=rest.nodeValue.replace(/^ /,'');
      var br=document.createElement('br'); br.className='gs-pdBr';
      var sp=document.createTextNode(' ');
      last.parentNode.insertBefore(sp,rest); last.parentNode.insertBefore(br,rest);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();
;
/* FAQ SLIDE (26 Oct 2026, Lan): the FAQ answers slide open and closed like the teaser boxes (0.4 s, ease) instead of jumping.
   Works on <details class="faq"> with a .faqA answer; the details element still opens and closes natively, the script only animates the height.
   Visitors with reduced motion get the instant open as before. Runs again when the theme editor reloads a section. */
(function(){
  var calm=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  function setup(root){
    Array.prototype.forEach.call((root&&root.querySelectorAll?root:document).querySelectorAll('details.faq'),function(det){
      if(det.getAttribute('data-gs-faq')) return; det.setAttribute('data-gs-faq','1');
      var sum=det.querySelector('summary'), ans=det.querySelector('.faqA'); if(!sum||!ans||!ans.animate) return;
      var anim=null;
      sum.addEventListener('click',function(e){
        if(calm.matches) return;
        e.preventDefault();
        if(anim){ anim.cancel(); anim=null; }
        ans.style.overflow='hidden';
        if(!det.open){
          det.open=true;
          var cs=getComputedStyle(ans), h=ans.offsetHeight;
          anim=ans.animate([{height:'0px',paddingTop:'0px',paddingBottom:'0px',opacity:0},{height:h+'px',paddingTop:cs.paddingTop,paddingBottom:cs.paddingBottom,opacity:1}],{duration:400,easing:'ease'});
          anim.onfinish=function(){ ans.style.overflow=''; anim=null; };
        } else {
          var cs2=getComputedStyle(ans), h2=ans.offsetHeight;
          anim=ans.animate([{height:h2+'px',paddingTop:cs2.paddingTop,paddingBottom:cs2.paddingBottom,opacity:1},{height:'0px',paddingTop:'0px',paddingBottom:'0px',opacity:0}],{duration:350,easing:'ease',fill:'forwards'});
          anim.onfinish=function(){ det.open=false; var a=anim; anim=null; ans.style.overflow=''; requestAnimationFrame(function(){ if(a) a.cancel(); }); };
        }
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();

/* SMOOTH ANCHORS (26.10.2026): smooth scrolling only for our own in-page links (CTA → #offer etc.).
   Page-wide CSS smooth scroll is off so that Rapid Cart's scroll restore on close is instant. */
(function(){
  if(window.gsSmoothAnchors) return; window.gsSmoothAnchors=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href^="#"]');
    if(!a||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    if(!a.closest('.sfg-lp-section')) return;
    var id=decodeURIComponent(a.getAttribute('href').slice(1)); if(!id) return;
    var t=document.getElementById(id); if(!t) return;
    e.preventDefault();
    t.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
    if(history.pushState) history.pushState(null,'','#'+id); else location.hash=id;
  });
})();
